<script setup lang="ts">
const router = useRouter();

const ending = 'Hahnemühle';
const pageTitle = computed(() => {
	const title = router.currentRoute.value.meta.title;
	if (title) {
		return `${title} · ${ending}`;
	}

	return ending;
});

useHead({
	link: [
		{ rel: 'icon', type: 'image/png', href: '/favicon-96x96.png', sizes: '96x96' },
		{ rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
		{ rel: 'shortcut icon', href: '/favicon.ico' },
		{ rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
		{ rel: 'manifest', href: '/site.webmanifest' },
	],
	htmlAttrs: {
		// Add a class to the html element based on the application code
		class: useApplicationCode().htmlClass.value,
	},
});

useSeoMeta({
	title: 'Hahnemühle',
	ogTitle: 'Hahnemühle',
	description: '',
	ogDescription: '',
	msapplicationTileColor: '#FFF',
	themeColor: '#FFF',
});

const { loadRecaptcha } = useRecaptcha();

loadRecaptcha();

const cookieAppId: CookieApp = 'auth';
useCookieScripts(cookieAppId);
</script>

<template>
	<div>
		<Title>
			{{ pageTitle ?? ending }}
		</Title>

		<HmOfflineNotice />

		<NuxtLayout>
			<NuxtPage />
			
		</NuxtLayout>

		<HmCookieConsent :app="cookieAppId" />
		<HmImprint />
	</div>
</template>
